import DejaVenu from "./DejaVenu.tsx";
import useFicheAppel from "../hooks/useFicheAppel.tsx";
import PatientEntry from "./PatientEntry.tsx";
import PageChooser from "./PageChooser.tsx";
import PatientsCandidatsWidget from "./PatientsCandidatsWidget.tsx";
import {Button} from "@/components/ui/button";

interface FirstPageProps {
  onNextPage: () => void;
}

const FirstPage = (props: FirstPageProps) => {
  const {
    dejaVenu,
    birthdate,
    ddnLookup,
    name,
    forename,
    onPrenomChange,
    onDDNChange,
    onNomChange,
    isValidDdn,
    setDejaVenu,
    isNewPatientMode,
    candidates,
    onResetFicheAppel,
  } = useFicheAppel();
  const showNext = isValidDdn && forename && birthdate;
  console.log("isNewPatientMode", isNewPatientMode);
  return (
    <div>
      <Button onClick={onResetFicheAppel} variant="destructive">
        Nouvelle Fiche
      </Button>
      <DejaVenu
        dejaVenuOui={dejaVenu === true}
        dejaVenuNon={dejaVenu === false}
        setDejaVenu={setDejaVenu}
      />
      {dejaVenu !== null ? (
        <PatientEntry
          birthdate={ddnLookup}
          name={name}
          forename={forename}
          onNameChange={onNomChange}
          onForenameChange={onPrenomChange}
          onBirthdateChange={onDDNChange}
          isValidDdn={isValidDdn}
          isNewPatientMode={isNewPatientMode}
        />
      ) : null}
      <PatientsCandidatsWidget
        isNewPatientMode={isNewPatientMode}
        candidats={candidates}
      />
      {showNext ? (
        <PageChooser
          onNextPage={props.onNextPage}
          prevPageEnabled={false}
          nextPageEnabled={true}
          nextPageText="Suivant"
        />
      ) : null}
    </div>
  );
};

export default FirstPage;
